/* Nav 4-zone mega panel — Zone 3 hover preview.
   Each Browse category tile with a linked-collection image has a matching, pre-
   rendered "hero" preview card in the stage (Zone 3). Hovering a tile reveals its
   card (image + first products); the preview STAYS while the pointer is anywhere in
   the Browse rail or over the stage — so it's reachable and clickable — and reverts
   to "Popular right now" only when the pointer moves to another zone or leaves the
   panel. Delegated + self-guarded. */
(function () {
  if (window.__navMegaPreviewInit) return;
  window.__navMegaPreviewInit = true;

  // Is any panel currently showing a hover preview? Lets the document-level
  // handler early-return without a page-wide querySelectorAll on every pointer
  // move when there's nothing to clear.
  var previewing = false;

  /* The preview cards ship inside a <template> (snippets/nav-mega-zones.liquid) so
     they cost nothing on page load — inert content, no layout, no image fetches.
     Inflate a panel's template the first time the pointer or focus reaches its menu,
     which happens before the pointer can travel to a tile, so the reveal is still
     instant and needs no network request.

     `pending` counts templates still sealed (-1 = not counted yet) so that once every
     menu has been opened this whole path costs one integer compare per event. */
  var pending = -1;

  function countPending() {
    if (pending < 0) pending = document.querySelectorAll('template[data-mega-previews]').length;
    return pending;
  }

  function hydrate(panel) {
    if (countPending() === 0) return;            // steady state: one integer compare
    var tpl = panel.querySelector('template[data-mega-previews]');
    if (!tpl) return;
    tpl.parentNode.insertBefore(tpl.content, tpl);
    tpl.parentNode.removeChild(tpl);
    pending -= 1;
  }

  // Highlight the rail tile(s) whose preview id matches (null = clear all).
  function setTiles(panel, id) {
    var tiles = panel.querySelectorAll('.mega-tile[data-preview-id]');
    for (var i = 0; i < tiles.length; i++) {
      tiles[i].classList.toggle('is-active', id != null && tiles[i].getAttribute('data-preview-id') === id);
    }
  }

  function clear(panel) {
    panel.classList.remove('is-previewing');
    var cards = panel.querySelectorAll('[data-preview-for]');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('is-active');
    setTiles(panel, null);
    previewing = false;
  }

  function clearAll() {
    if (!previewing) return;                     // nothing active — skip the doc query
    var open = document.querySelectorAll('.mega-nav--zones.is-previewing');
    for (var i = 0; i < open.length; i++) clear(open[i]);
    previewing = false;
  }

  function show(panel, id) {
    var cards = panel.querySelectorAll('[data-preview-for]');
    var matched = false;
    for (var i = 0; i < cards.length; i++) {
      var on = cards[i].getAttribute('data-preview-for') === id;
      cards[i].classList.toggle('is-active', on);
      if (on) matched = true;
    }
    panel.classList.toggle('is-previewing', matched);
    setTiles(panel, id);
    previewing = matched;
  }

  /* Inflate from a target that is NOT inside a panel — i.e. the top-level <summary>,
     hovered while the panel is still opening. Callers that already have the panel
     should call hydrate() directly. */
  function hydrateFromItem(target) {
    if (countPending() === 0) return;            // every menu already inflated
    if (!target || !target.closest) return;
    var item = target.closest('.js-mega-nav');
    if (!item) return;
    var panel = item.querySelector('.mega-nav--zones');
    if (panel) hydrate(panel);
  }

  // Keyboard users never fire mouseover — inflate on focus entry too.
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var panel = t.closest('.mega-nav--zones');
    if (panel) hydrate(panel); else hydrateFromItem(t);
  });

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var panel = t.closest('.mega-nav--zones');
    if (!panel) {                                // left the panel entirely (self-guards)
      hydrateFromItem(t);                        // ...but may be on a closed menu's summary
      clearAll();
      return;
    }

    hydrate(panel);                              // no-op once inflated

    var tile = t.closest('.mega-tile[data-preview-id]');
    if (tile) { show(panel, tile.getAttribute('data-preview-id')); return; }

    // keep the current preview while hovering anywhere in Browse or the stage
    if (t.closest('[data-nav-zone="browse"]') || t.closest('[data-nav-zone="heroes"]')) return;

    clear(panel);                                  // moved to Fit/Help/etc. -> back to heroes
  });
})();
